import { all, call, fork, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { FORGET_PASSWORD } from "./actionTypes"
import { userForgetPasswordError, userForgetPasswordSuccess } from "./actions"

import { postJwtForgetPwd } from "../../../helpers/backend_helper"

function* forgetUser({ payload: { user, history } }) {
  try {
    const response = yield call(postJwtForgetPwd, user)
    if (response) {
      yield put(userForgetPasswordSuccess(response))
    }
  } catch (error) {
    yield put(userForgetPasswordError(error))
  }
}

export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser)
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget)])
}

export default forgetPasswordSaga
